import React, { useContext } from 'react'
import classNames from 'classnames'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { ShowcaseEntryProps } from './ContentfulNavigation.d'

const ShowcaseEntry = ({
  badge,
  dataTestId = 'ShowcaseEntry',
  description,
  heapClass,
  hideBadgeDesktop,
  isMobileMainNav,
  menuType = 'desktop',
  mobileDescription,
  mobileTitle,
  thumbnail,
  title,
  url
}: ShowcaseEntryProps) => {
  const localizationContext = useContext(I18nextContext)

  const showcaseHref = localizeLink(
    url,
    localizationContext.language,
    localizationContext
  )

  const showcaseClasses = classNames(
    heapClass,
    'flex font-effra p-4 lg:p-2 w-full lg:max-w-[264px] rounded-lg bg-neutral group border hover:border-blue-75 focus:border-blue-75 hover:shadow-elevated transition-shadow',
    { 'mb-4': !isMobileMainNav }
  )

  const entryTitle = menuType === 'mobile' && mobileTitle ? mobileTitle : title
  const entryDescription =
    menuType === 'mobile' && mobileDescription ? mobileDescription : description

  const showBadge =
    badge &&
    (menuType === 'mobile' || (menuType === 'desktop' && !hideBadgeDesktop))

  return (
    <a
      className={showcaseClasses}
      data-testid={dataTestId}
      href={showcaseHref}
      key={`${menuType}-sub-menu-showcase-${title}`}
      role='menuitem'
    >
      {thumbnail ? (
        <img
          alt=''
          className='w-[100px] min-h-[100px] mr-3 h-full object-cover self-stretch hidden 2xl:block rounded-sm'
          src={`${thumbnail}?w=150&h=150&fit=fill`}
        />
      ) : null}
      <div className='self-center'>
        {showBadge ? (
          <div className='w-full'>
            <Badge
              badgeColor={badge.color}
              classes='mb-1 font-sansPro text-[12px] leading-[14px] tracking-[1.2px]'
              text={badge.title}
              uppercase
            />
          </div>
        ) : null}
        <p className='font-effra text-default tracking-normal lg:leading-[120%] mb-1 text-base lg:text-[15px]'>
          {entryTitle}
        </p>
        <p className='font-sansPro font-normal text-secondary text-xs'>
          {entryDescription}
        </p>
      </div>
    </a>
  )
}

export default ShowcaseEntry
